<section class="widget-section">
  <div class="container pt-5 pb-6">
    <app-project-list view="my"></app-project-list>
  </div>
</section>
